const location = {
  lat: 46.55938395520632,
  lng: 15.643253663056553,
  address: "Slomškov trg 15",
  postalCode: "2000",
  department: "Prostor",
  phone_number: "+386 2 23 55 337",
  email: "bri@um.si",
};

export { location };
